import axiosInstance from "@/composables/axios-instance";
import router from "@/router";
import { toast } from "vue3-toastify";

const state = {
  productsList: [],
  adminsProductsList: [],
  categoriesList: [],
  shelvesList: [],
  unitsList: [],
  productDetail: {},
  showList: true,
  inventoryCycle: [],
};

const getters = {
  getProductsList(state) {
    return state.productsList;
  },
  getAdminsProductsList(state) {
    return state.adminsProductsList;
  },
  getCategoriesList(state) {
    return state.categoriesList;
  },
  getShelvesList(state) {
    return state.shelvesList;
  },
  getUnitsList(state) {
    return state.unitsList;
  },
  getProductDetail(state) {
    return state.productDetail;
  },
  getShowList(state) {
    return state.showList;
  },
  getInventoryCycle(state) {
    return state.inventoryCycle;
  },
};

const mutations = {
  setProductsList(state, list) {
    state.productsList = list;
  },
  setAdminsProductsList(state, list) {
    state.adminsProductsList = list;
  },
  setCategoriesList(state, list) {
    state.categoriesList = list;
  },
  setShelvesList(state, list) {
    state.shelvesList = list;
  },
  setUnitsList(state, list) {
    state.unitsList = list;
  },
  setProductDetail(state, detail) {
    state.productDetail = detail;
  },
  setShowList(state, showList) {
    state.showList = showList;
  },
  setInventoryCycle(state, inventoryCycle) {
    state.inventoryCycle = inventoryCycle;
  },
};

const actions = {
  getProductsListFromApi({ commit }, filter) {
    let filters = {};
    for (let key in filter) {
      if (filter[key] != "") filters[key] = filter[key];
    }
    return axiosInstance
      .get("/product/report/", {
        params: filters,
      })
      .then((response) => {
        commit("setProductsList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getAdminsProductsListFromApi({ commit }, filter) {
    let filters = {};
    for (let key in filter) {
      if (filter[key] != "") filters[key] = filter[key];
    }
    return axiosInstance
      .get("/product/report/admin/", {
        params: filters,
      })
      .then((response) => {
        commit("setAdminsProductsList", response.data);
      })
      .catch((error) => {
        console.error(error);
        if(error.status == 403)
          router.push({name: "dashboard"});
      });
  },
  getInformationList({ commit }) {
    return axiosInstance
      .get("/list-information/")
      .then((response) => {
        commit("setCategoriesList", response.data.categories);
        commit("setShelvesList", response.data.shelves);
        commit("setUnitsList", response.data.units);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  /* eslint-disable */
  createProduct({ }, product) {
    /* eslint-disable */
    return axiosInstance
      .postForm("/product/create/", {
        stock: product.stock,
        name: product.name,
        is_deleted: false,
        category: product.category,
        shelf: product.shelf,
        unit: product.unit,
        image: product.image,
      })
      .then((response) => {
        toast.success("کالا با موفقیت ایجاد شد");
      })
      .catch((error) => {
        toast.error("کالا ساخته نشد لطفا بعدا تلاش کنید");
      });
  },
  deleteProduct({ }, id) {
    return axiosInstance
      .delete("/product/delete/", { data: { id } })
      .then((response) => {
        toast.success("کالا با موفقیت غیرفعال شد");
      })
      .catch((error) => {
        toast.error("در غیرفعال کردن کالا مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },
  undeleteProduct({ }, id) {
    return axiosInstance
      .delete("/product/undelete/", { data: { id } })
      .then((response) => {
        toast.success("کالا با موفقیت فعال شد");
      })
      .catch((error) => {
        toast.error("در فعال کردن کالا مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },
  getProductDetailFromApi({ commit }, id) {
    return axiosInstance
      .post("/product/detail/", {
        id: id,
      })
      .then((response) => {
        commit("setProductDetail", response.data);
      })
      .catch((error) => {
        toast.error("اطلاعات کالای مورد نظر یافت نشد");
      });
  },
  updateProductDetail({ dispatch }, { id, product }) {
    let requestData = {};
    for (let key in product) {
      if (product[key] != "") requestData[key] = product[key];
    }
    requestData.id = id;
    return axiosInstance
      .putForm(`/product/update/`, requestData)
      .then((response) => {
        toast.success("تغییرات با موفقیت اعمال شد.")
      })
      .catch((error) => {
        toast.error("اطلاعات تغییر نیافت لطفا بعدا تلاش کنید");
      });
  },
  getInventoryCycleData({ commit }, query) {
    return axiosInstance
      .get("/inventory/cycle/", {
        params: {
          page: query.page,
          page_size: query.page_size,
          category: query.category,
          shelf: query.shelf,
          unit: query.unit,
          name: query.name,
          stock: query.stock,
          date_range: query.date_range,
          prefer: query.prefer,
        },
      })
      .then((response) => {
        commit("setInventoryCycle", response.data);
      })
      .catch((error) => {
        toast.error("مشکلی در دریافت اطلاعات به وجود آمده لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },
  getProductsExcel() {
    return axiosInstance
      .get("/product/excel/", {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const filename = "Products List.xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Error:", err));
  },
  getInventoryCycleExcel() {
    return axiosInstance
      .get("/inventory/excel/", {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const filename = "Inventory Cycle List.xlsx";
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Error:", err));
  },

  createCategory(_, persianName) {
    return axiosInstance
      .post("/category/create/", {
        persian_name: persianName,
      })
      .then((response) => {
        toast.success("ساخت دسته‌بندی با موفقیت انجام شد.");
      })
      .catch((error) => {
        toast.error("دسته‌بندی ساخته نشد. لطفا بعدا تلاش کنید.");
      });
  },

  createShelf(_, persianName) {
    return axiosInstance
      .post("/shelf/create/", {
        persian_name: persianName,
      })
      .then((response) => {
        toast.success("ساخت قفسه با موفقیت انجام شد.");
      })
      .catch((error) => {
        toast.error("قفسه ساخته نشد. لطفا بعدا تلاش کنید.");
      });
  },

  createUnit(_, persianName) {
    return axiosInstance
      .post("/unit/create/", {
        persian_name: persianName,
      })
      .then((response) => {
        toast.success("ساخت واحد با موفقیت انجام شد.");
      })
      .catch((error) => {
        toast.error("واحد ساخته نشد. لطفا بعدا تلاش کنید.");
      });
  },

  deleteCategory(_, id) {
    return axiosInstance
      .delete("/category/delete/", { data: { id } })
      .then(() => {
        toast.success("دسته‌بندی مورد نظر با موفقیت حذف شد.");
      })
      .catch(() => {
        toast.error("دسته‌بندی حذف نشد لطفا بعدا تلاش کنید.");
      });
  },

  deleteShelf(_, id) {
    return axiosInstance
      .delete("/shelf/delete/", { data: { id } })
      .then(() => {
        toast.success("قفسه مورد نظر با موفقیت حذف شد.");
      })
      .catch(() => {
        toast.error("قفسه حذف نشد لطفا بعدا تلاش کنید.");
      });
  },

  deleteUnit(_, id) {
    return axiosInstance
      .delete("/unit/delete/", { data: { id } })
      .then(() => {
        toast.success("واحد مورد نظر با موفقیت حذف شد.");
      })
      .catch(() => {
        toast.error("واحد حذف نشد لطفا بعدا تلاش کنید.");
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
